import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Shield, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Login() {
    const { admin, login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    if (admin) return <Navigate to="/" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) navigate("/");
        else setError(res.error);
    };

    return (
        <div className="min-h-screen bg-[#F4F4F5] bg-dots flex items-center justify-center px-4">
            <div className="w-full max-w-md" data-testid="login-page">
                <div className="flex items-center gap-3 mb-8 justify-center">
                    <div className="w-11 h-11 bg-[#FA3E05] rounded-md flex items-center justify-center">
                        <Shield className="w-5 h-5 text-white" strokeWidth={2.25} />
                    </div>
                    <div className="text-left leading-tight">
                        <div className="text-xl font-semibold tracking-tight">Youstylist Admin</div>
                        <div className="text-[11px] uppercase tracking-widest text-zinc-500 font-mono">
                            personal styling · wardrobe · looks
                        </div>
                    </div>
                </div>

                <form
                    onSubmit={submit}
                    className="bg-white border border-zinc-200 rounded-md p-6 space-y-4"
                >
                    <div>
                        <h1 className="text-lg font-semibold tracking-tight">Вход в панель</h1>
                        <p className="text-sm text-zinc-500 mt-1">Введите учётные данные администратора</p>
                    </div>

                    <div className="space-y-1.5">
                        <label className="text-xs font-medium text-zinc-700 uppercase tracking-wider">Email</label>
                        <input
                            data-testid="login-email-input"
                            type="email" required value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-3 py-2 bg-white border border-zinc-200 rounded-md text-sm font-mono focus:outline-none focus:ring-2 focus:ring-[#FA3E05] focus:ring-offset-0 focus:border-[#FA3E05]"
                            placeholder="you@example.com"
                        />
                    </div>

                    <div className="space-y-1.5">
                        <label className="text-xs font-medium text-zinc-700 uppercase tracking-wider">Пароль</label>
                        <input
                            data-testid="login-password-input"
                            type="password" required value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="w-full px-3 py-2 bg-white border border-zinc-200 rounded-md text-sm font-mono focus:outline-none focus:ring-2 focus:ring-[#FA3E05] focus:ring-offset-0 focus:border-[#FA3E05]"
                            placeholder="••••••••"
                        />
                    </div>

                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-md px-3 py-2" data-testid="login-error">
                            {error}
                        </div>
                    )}

                    <button
                        data-testid="login-submit-btn"
                        type="submit" disabled={loading}
                        className="w-full bg-[#FA3E05] hover:bg-[#E03504] disabled:opacity-60 text-white text-sm font-medium rounded-md py-2.5 transition-colors flex items-center justify-center gap-2"
                    >
                        {loading && <Loader2 className="w-4 h-4 animate-spin" />}
                        Войти
                    </button>
                </form>

                <p className="text-center text-xs text-zinc-500 mt-6 font-mono">
                    youstylist · internal tools
                </p>
            </div>
        </div>
    );
}
